import { NegativeColors, PositiveColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

import { DEFAULT_COLOR_SCHEME } from 'redesignedComponents/context/colorScheme';
import { ColorSchemeType } from 'redesignedComponents/context/colorScheme/types';

type StyleProps = {
  colorScheme: ColorSchemeType;
};

const useStyles = createUseStyles<string, StyleProps>(
  () => ({
    root: ({ colorScheme }) => {
      return {
        padding: [Spacings.s72, 124],
        backgroundColor:
          colorScheme === DEFAULT_COLOR_SCHEME
            ? PositiveColors.base.default
            : NegativeColors.base.default,
        color:
          colorScheme === DEFAULT_COLOR_SCHEME
            ? PositiveColors.text.default
            : NegativeColors.text.default,
        // [mediaQuery(767)]: {
        '@media screen and (max-width: 767px)': {
          padding: Spacings.s48,
        },
      };
    },
    content: {
      display: 'flex',
      columnGap: 80,
      justifyContent: 'center',
    },
    contentForMedia: {
      // [mediaQuery(1000)]: {
      '@media screen and (max-width: 1000px)': {
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    imageContainer: {
      height: 558,
      width: 478,
      // [mediaQuery(1000)]: {
      '@media screen and (max-width: 1000px)': {
        width: '100%',
        maxWidth: 478,
        marginBottom: Spacings.s40,
      },
    },
    title: {
      marginBottom: Spacings.s72,
      textAlign: 'center',
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        marginBottom: Spacings.s44,
      },
    },
    summaryItem: {
      width: '100%',
      maxWidth: 576,
      margin: 'auto',
    },
    image: {
      height: '100%',
      width: '100%',
      '& img': {
        borderRadius: CornerRadius.r16,
      },
      // [mediaQuery(1000)]: {
      '@media screen and (max-width: 1000px)': {
        objectFit: 'cover',
      },
    },
    summaryTitle: {
      paddingBottom: Spacings.s6,
      fontWeight: FontWeights.semibold,
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l28,
    },
    summaryDescription: {
      paddingBottom: Spacings.s32,
      fontWeight: FontWeights.normal,
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l28,
    },
    // skeleton
    skeletonRoot: {
      padding: [Spacings.s72, Spacings.s72],
      width: '100%',
      height: 500,
      '& *': {
        borderRadius: CornerRadius.r12,
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: Spacings.s48,
      },
    },
    skeletonTitle: {
      width: 800,
      height: 50,
      margin: [Spacings.s0, 'auto', Spacings.s72, 'auto'],
      // [mediaQuery(1000)]: {
      '@media screen and (max-width: 1000px)': {
        width: '100%',
      },
    },
    skeletonItemDescription: {
      width: '100%',
      height: 150,
      marginTop: 20,
    },
    skeletonItem: {
      maxWidth: 576,
      width: '100%',
      height: 400,
      marginTop: 40,
      margin: [0, 'auto'],
    },
    skeletonItemTitle: {
      width: '100%',
      height: 30,
    },
  }),
  {
    name: 'summary',
  },
);

export default useStyles;
